import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const roleParamGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const storedRole = localStorage.getItem('userRole');
  const routeRole = route.paramMap.get('role');

  if (storedRole && routeRole === storedRole) {
    return true;
  }

  return router.createUrlTree(['/not-found']);
};
